// extracted by mini-css-extract-plugin
export default {"card":"TldlCard_card__ZBlKz"};